<template>
    <!-- FOOTER -->
    <div class="footer-section">
        <div class="footer-section-bg-graphics">
            <img src="../assets/images/footer-section-bg.png">
        </div>
        <!-- Footer Column 1 -->
        <div class="container footer-container">
            <div class="col-lg-4 col-md-6 footer-logo">
                <img src="../assets/images/logo-white.svg">
                <p class="footer-susection-text">Brengt families dichter bij elkaar.</p>
            </div>
            <div class="col-lg-4 col-md-6 footer-subsection">
                <div class="footer-subsection-2-1">
                    <h3 class="footer-subsection-title">Over ons</h3>
                    <p class="footer-subsection-text">Gepassioneerd door zorg & verbondenheid.</p>
                </div>
            </div>
            <!-- Footer Column 2 -->
            <div class="col-lg-4 col-md-6 footer-subsection">
                <h3 class="footer-subsection-title">Contacteer</h3>
                <ul class="footer-subsection-list">
                    <li>info@familyportal.be</li>
                    <li>+32 471 48 54 19</li>
                </ul>	
            </div>
            <!-- Footer Column 3 -->
            <!-- <div class="col-lg-3 col-md-6 footer-subsection">
                <div class="footer-subsection-2-2">
                    <h3 class="footer-subsection-title">Socials</h3>
                    <div class="footer-social-media-icons-section">
                        <a href="#top" class="footer-social-media-icon"><i class="fa fa-twitter"></i></a> 
                        <a href="#top" class="footer-social-media-icon"><i class="fa fa-instagram"></i></a>
                        <a href="#top" class="footer-social-media-icon"><i class="fa fa-facebook"></i></a>
                        <a href="#top" class="footer-social-media-icon"><i class="fa fa-linkedin"></i></a>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- FOOTER CREDITS -->
        <div class="container footer-credits">
            <p>&copy; 2020 <a href="https://www.concept-it.be" target="_blank" title="Concept-IT">Concept-IT</a>&trade;. Alle rechten voorbehouden.</p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>